import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { digObject, matchFilterString, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

const watchEntityKeys = ['serviceProducts']

const useAssignedPublications = (serviceProduct, filters) => {
  const assignedPublicationIds = digObject(serviceProduct, 'options.publication.compatible_publications', [])

  const { string } = filters

  const {
    updatedEntities: { serviceProducts: serviceProductsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { publications } = useSelector(reduxState => reduxState.entities)

  const filteredPublications = useMemo(() => {
    const filtered = assignedPublicationIds.map(id => publications[id]).filter((publication) => {
      const { title } = publication || {}

      const matchString = matchFilterString(title, string)

      return publication?.id && matchString
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [serviceProductsUpdatedAt, JSON.stringify(filters)])

  const hasFilteredPublications = !!filteredPublications.length
  const hasAssignedPublications = !!assignedPublicationIds.length

  return {
    filteredPublications,
    hasAssignedPublications,
    hasFilteredPublications,
  }
}

export default useAssignedPublications
